// 首頁、連載首頁、漫畫首頁
import moment from 'moment'

export default {
  moment: function (date) {
    return moment(date).format('YYYY/MM/DD')
  }
}



// WEBPACK FOOTER //
// ./src/filters.js